import i18n from 'helpers/i18n';
import messages from './messages';
import exitTest from 'images/reliabilityTest/exitTest.svg';
import { Button } from '@teachstonellc/component-library';

export interface CalibrationBottomSectionProps {
  onSaveAndExit: () => void;
  onContinue: () => void;
}

function CalibrationBottomSection(props: CalibrationBottomSectionProps) {
  var { onSaveAndExit, onContinue } = props;

  return (
    <div className="PrintBottomSection bg-[#F9F9F9] py-8 px-2 mb-0 p-1 sm:px-8 sm:py-3 lg:px-20 lg:py-3 lg:mx-12 lg:mb-[50px] lg:pb-[50px] rounded-br-2xl rounded-bl-2xl">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:flex-row md:gap-6 items-center justify-between">
        <div className="grid-span-1 gap-4 w-full md:w-auto">
          <button
            type="button"
            onClick={onSaveAndExit}
            className="flex items-center justify-center border-0 rounded-lg pl-3 pr-6 py-3 bg-[#F9F9F9] text-gray-700 font-semibold text-lg transition hover:bg-gray-100 w-full md:w-auto"
          >
            <img src={exitTest} alt="" className="mr-5" />
            {i18n.ft(messages.exitTest)}
          </button>
        </div>

        <div className="grid-span-1 gap-4 w-full"></div>

        <div className="grid-span-1 gap-4 w-full">
          <Button fullWidth variant="primary" onClick={onContinue}>
            {i18n.ft(messages.continue)}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default CalibrationBottomSection;
